export default {
  LocationsPlaceholder: 'LocationsPlaceholder',
  Access: 'Access',
  FulfillmentRules: 'Fulfillment Rules',
  InventoryDistribution: 'Inventory Distribution'
}
